/**
 * PDP product description: line-clamp with Read more / Read less (see Description block settings).
 */
(function () {
  function measureOverflow(wrapper, desc) {
    var wasExpanded = wrapper.classList.contains('is-expanded');
    wrapper.classList.remove('is-expanded');
    void desc.offsetHeight;
    var overflow = desc.scrollHeight > desc.clientHeight + 2;
    if (wasExpanded) wrapper.classList.add('is-expanded');
    return overflow;
  }

  function setExpanded(wrapper, btn, labelEl, readMoreLabel, readLessLabel, expanded) {
    wrapper.classList.toggle('is-expanded', expanded);
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (labelEl) {
      labelEl.textContent = expanded ? readLessLabel : readMoreLabel;
    }
  }

  function initWrapper(wrapper) {
    if (wrapper.getAttribute('data-read-more-init') === '1') return;
    var desc = wrapper.querySelector('[data-product-description-clamp]');
    var btn = wrapper.querySelector('[data-product-description-toggle]');
    if (!desc || !btn) return;

    var labelEl = btn.querySelector('[data-toggle-text]');
    var readMoreLabel = btn.getAttribute('data-read-more-label') || 'Read more';
    var readLessLabel = btn.getAttribute('data-read-less-label') || 'Read less';

    if (!measureOverflow(wrapper, desc)) {
      btn.setAttribute('hidden', '');
      btn.setAttribute('aria-hidden', 'true');
      wrapper.setAttribute('data-read-more-init', '1');
      return;
    }

    btn.removeAttribute('hidden');
    btn.removeAttribute('aria-hidden');
    setExpanded(wrapper, btn, labelEl, readMoreLabel, readLessLabel, false);

    btn.addEventListener('click', function () {
      var expanded = !wrapper.classList.contains('is-expanded');
      setExpanded(wrapper, btn, labelEl, readMoreLabel, readLessLabel, expanded);
    });

    wrapper.setAttribute('data-read-more-init', '1');
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-product-description-read-more]').forEach(function (w) {
      initWrapper(w);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
